<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.regCode" label="车辆到达市场登记单编号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.productName" label="商品名称" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.salesDate" label="销售日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createByName" label="制单人" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </div>
      <van-collapse-item title="车辆及货物信息" name="1">
        <template v-if="inputForm.transferType !== '1'">
          <van-field v-model="inputForm.domesticConsignName" label="境内发车地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.domesticDepartureDate" label="境内发车日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.domesticDepartTripNo" label="境内发车车次" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.domesticPlateNo" label="境内运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.transferDate" label="口岸换装日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.internationalPlateNo" label="国际运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.salesPlaceName" label="销售地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.arrivalDate" label="到达市场时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.arrivalTripNo" label="到达市场车次" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.departNum" label="发车件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.departTotalWeight" label="发车含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.averageWeightPerBasket" label="单件均重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.totalNum" label="口岸换装总件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          <van-field v-model="inputForm.totalWeight" :formatter="formatter" label="口岸换装含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        </template>

        <template v-if="inputForm.salesDepartInfoList && inputForm.salesDepartInfoList.length > 0 && inputForm.transferType === '1'">
          <div v-for="(sdInfo, sdIndex) in inputForm.salesDepartInfoList" :key="sdIndex">
            <div class="title">境内发车信息（{{ sdInfo.salesDepartCode }}）</div>
            <van-field v-model="sdInfo.domesticConsignName" label="境内发车地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.domesticDepartureDate" label="境内发车日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.domesticDepartTripNo" label="境内发车车次" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.domesticPlateNo" label="境内运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.transferDate" label="口岸换装日期" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.internationalPlateNo" label="国际运输车牌号" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.salesPlaceName" label="销售地点" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.arrivalDate" label="到达市场时间" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.arrivalTripNo" label="到达市场车次" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.domesticTruckNum" label="发车件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.domesticTotalWeightExcludePack" :formatter="formatter" label="发车含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.averageWeightPerBasket" :formatter="formatter" label="单件均重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.totalNum" label="口岸换装总件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
            <van-field v-model="sdInfo.totalWeight" :formatter="formatter" label="口岸换装含筐总重（斤）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
          </div>
        </template>
        <div style=" margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
          <p style="display: block; color: #4caedc" @click="viewDetail()">查看当日销售信息信息</p>
        </div>
      </van-collapse-item>
      <van-collapse-item title="当日损耗信息" name="2">
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.destroys" :fields="fields1" foot-clone>
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(weight)="data">
            {{ Number(data.item.weight).toFixed(2) }}
          </template>
          <template v-slot:cell(reason)="data">
            <div style="color: #4caedc;" @click="showDetail(data.item.reason)">{{ data.item.reason }}</div>
          </template>
          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
          <template v-slot:foot()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}"></div>
          </template>
          <template v-slot:foot(index)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">小计</div>
          </template>
          <template v-slot:foot(num)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum1(inputForm.destroys, 'num') }}</div>
          </template>
          <template v-slot:foot(weight)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(inputForm.destroys, 'weight') }}</div>
          </template>
        </b-table>
      </van-collapse-item>
      <van-collapse-item title="本车累计信息" name="3">
        <van-field v-model="inputForm.sumNo" label="累计销售件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.sumAmount" :formatter="formatter" label="累计销售金额（元）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.sumDestroyNum" label="累计损耗数量（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remainingStock" label="剩余库存件数（筐）" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
        <van-field v-model="inputForm.remarks" label="备注" label-width="110px" readonly input-align="left" :border="false" autosize rows="1" type="textarea" />
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>


<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
import {Decimal} from "decimal.js";

export default {
  name: "ItsSalesVehicle",
  data() {
    return {
      activeNames: ['1', '2', '3', '4', '5'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        carFrontAttachList: [],
        carBodyAttachList: [],
        carTailAttachList: [],
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_sales_reg_once',
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'num', label: '损耗数量（筐）', width: '120px'},
        {key: 'weight', label: '损耗净重（斤）', width: '120px'},
        {key: 'reason', label: '损耗原因', width: '120px'},
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/sales/itsSalesRegOnce/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0,10)
        this.updateDictNames(this.inputForm.details,{
          sales_pay_type:'outPayType'
        })
      }).catch(e => {
        console.log(e)
      })
    },
    async updateDictNames(dataList, dictTypeList) {
      const {data} = await new QueryInfoService().getDictMap();
      const promises = dataList.map(async (item) => {
        for (const [dictType, formField] of Object.entries(dictTypeList)) {
          if (data[dictType] && Array.isArray(data[dictType])) {
            const dictItem = data[dictType].find(d => d.value === item[formField]);
            if (dictItem) {
              this.$set(item, `${formField}Label`, dictItem.label);
            }
          }
        }
      });
    },
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    sumNum1(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(0, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/comm/flow/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
    viewDetail() {
      this.$router.push({
        path: '/ItsSalesVehicleSalesDetail',
        query: {
          data: JSON.stringify(this.inputForm.details)
        }
      })
    },
    showDetail(content) {
      if(content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #323233;
  padding: 12px 16px;
  background-color: #f7f8fa;
  border-left: 3px solid #1989fa;
  margin-bottom: 8px;
}
</style>
